const resizeCallbacks = []

export const viewport = {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: Math.min(window.devicePixelRatio, 2),
}

export const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0

export const onResize = (callback) => {
    resizeCallbacks.push(callback)
}

window.addEventListener('resize', () => {
    viewport.width = window.innerWidth
    viewport.height = window.innerHeight
    viewport.pixelRatio = Math.min(window.devicePixelRatio, 2)

    for (const cb of resizeCallbacks) cb(viewport)
})
